import { Component, OnInit } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import {Router} from '@angular/router';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  email: string;
  password: string;
  showErrorMessage: boolean;
  errorMessage = 'We don\'t recognize this information. Check your credentials!';
  constructor(public auth: AngularFireAuth, private router: Router) { }

  ngOnInit() {
  }

  login() {
    this.auth.auth.signInWithEmailAndPassword(this.email, this.password).then((res) => {
      this.router.navigate(['/live']);
    }).catch((err) => {
      if (err.code === 'auth/user-not-found') {
        this.showErrorMessage = true;
        this.errorMessage = 'We don\'t recognize this information. Check your credentials!';
        setTimeout(() => this.showErrorMessage = false, 3000);
      } else if (err.code === 'auth/wrong-password') {
        this.errorMessage = 'Incorrect password.';
        this.showErrorMessage = true;
      } else {
        this.showErrorMessage = true;
      }
    });
  }

}
